import { Box, ButtonGroup, IconButton } from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";
import * as React from "react";
import { useNotify, useRefresh } from "react-admin";
import { useAppDataProvider } from "../../../src/dataprovider";
import { useAccessControl } from "@airborne/react-admin";

export const DataGridRowActions = (props: any) => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl("abilitycontrols");

  function deleteButtonClick() {
    let record = props.record;
    dataProvider
      .deleteAbilityControl(record?.id ?? 0)
      .then(result => {
        notify(`Record Deleted`, "success", false, true);
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {
        refresh();
      });
  }
  const DeleteButton = () => {
    return (
      <IconButton
        onClick={e => {
          e.stopPropagation();
          deleteButtonClick();
        }}
        color="primary"
      >
        <DeleteForever />
      </IconButton>
    );
  };

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <ButtonGroup variant="text" size="small">
        {canCreate && <DeleteButton />}
      </ButtonGroup>
    </Box>
  );
};
export default DataGridRowActions;
